export default __webpack_public_path__ + "static/media/151-book-bag-1.cd756d8a.png";